import { render } from "./Bots.vue?vue&type=template&id=2f2586d4&scoped=true"
import script from "./Bots.vue?vue&type=script&lang=js"
export * from "./Bots.vue?vue&type=script&lang=js"

import "./Bots.vue?vue&type=style&index=0&id=2f2586d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2586d4"]])

export default __exports__